export const primaryColor = "#556EE6"
export const secondaryColor = "#74788D"
export const SWITCH_HEIGHT = 24;
export const CIRCLE_DIAMETER = 20;

export const CROP_IMAGE_RATIO_16_9 = {
  ratio1: 16,
  ratio2: 9,
}